import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { GenericLinkModule } from '@spartacus/storefront'
import { EbLinkComponent } from './eb-link/eb-link.component'

@NgModule({
  imports: [GenericLinkModule, CommonModule, EbLinkComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        CMSLinkComponent: {
          component: EbLinkComponent
        }
      }
    } as CmsConfig)
  ]
})
export class CustomCmsComponentsModule {}
